import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';

interface Sidebar {
  open: boolean;
}

export default class sidebarStore {
  sidebar: Sidebar = {
    open: true,
  };
  masterFormList: {
    masterId: string;
    title: string;
    icon?: string;
  }[] = [];
  timer: any;

  constructor() {
    makeAutoObservable(this);
  }

  openSidebar = () => {
    clearTimeout(this.timer);
    this.sidebar.open = true;
  };

  closeSidebar = () => {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.sidebar.open = false;
    }, 300);
  };

  /**
   * side-bar master form list
   */
  getSidebarFormList = async () => {
    try {
      let result = await agent.SideBarAPIContainer.getFormDetailsAPI();

      runInAction(() => {
        if (result.data) {
          this.masterFormList = result.data;
        }
      });
    } catch (error) {
      toast.error('Pls Try Again !');
      console.log(error);
      return error;
    }
  };
}
